const apiUrl = process.env.REACT_APP_API_URL;

function getBasicAuthHeader() {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  return `Basic ${btoa(`${username}:${password}`)}`;
}

function authHeaders() {
  return { 'Content-Type': 'application/json', Accept: '*/*', Authorization: getBasicAuthHeader() };
}

/**
 * Platform revenue split → { platformFeePercent, instructorSharePercent }.
 * Single source of truth: the `role` table (GET /api/roles) — the same value the
 * System → Setting "Split Payment fee" screen manages (admin % = platform fee).
 */
export async function fetchRevenueSplit() {
  const res = await fetch(`${apiUrl}/api/roles`, { headers: authHeaders() });
  if (!res.ok) throw new Error(`Revenue split request failed: ${res.status}`);
  const roles = await res.json();
  const admin = (roles || []).find((r) => (r.role || '').toLowerCase() === 'admin');
  const platformFeePercent = admin ? Math.round(Number(admin.percentage) || 0) : 0;
  return { platformFeePercent, instructorSharePercent: 100 - platformFeePercent };
}
